import { IInvoice } from '@jumpstart/core';
import { CostBreakdown, InvoiceState } from '@jumpstart/core/dist/schemas/common/invoice/invoice';
import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import { addDoc, collection, QueryDocumentSnapshot, doc, DocumentReference, getFirestore } from 'firebase/firestore';
import React, { useState } from 'react';
import { useDocumentData } from 'react-firebase-hooks/firestore';
import { useParams } from 'react-router-dom';
import { app, db } from '../../../core/firebase';
import SubscriberOrdersProvider from '../providers/SubscriberOrdersProvider';
import SubscriberProvider from '../providers/SubscriberProvider';
import { ISubscriber } from '../schemas';
import InvoiceCreationView from './InvoiceCreationView';

function LoadingOrderCreationPage() {
  return (
    <Grid container direction="column">
      <Skeleton variant="rectangular" width={300} height={20}/>
    </Grid>
  );
}

export default function OrderCreationPage() {

  const { uid } = useParams<{ uid: string }>();
  const [invoice, setInvoice] = useState<QueryDocumentSnapshot | null>(null);
  const [subscriber, loading] = useDocumentData<ISubscriber>(doc(getFirestore(app), `scout9-sms-subscribers/${uid}`) as DocumentReference<ISubscriber>);

  const handleAddInvoice = () => {
    const newBreakdown: CostBreakdown = {
      shipping: 0,
      taxes: 0,
      fees: 0,
      subtotal: 0,
      discount: 0,
      total: 0,
      currency: 'USD'
    };
    const newInvoice: IInvoice = {
      state: InvoiceState.AWAITING_SUBMIT,
      estimate: newBreakdown,
      total: newBreakdown,
      discounts: []
    };
    addDoc(collection(db, `scout9-profiles/${uid}/dogs/default/invoices`), newInvoice)
      .catch((err: Error) => {
        console.error(`Unable to set invoice`, err);
      });
  };


  if (loading) {
    return (<LoadingOrderCreationPage/>);
  }

  if (!subscriber) {
    return (<Alert severity="error">No subscriber found</Alert>);
  }

  return (
    <SubscriberProvider subscriber={subscriber}>
      {
        ({ dog, profile, subscriber, messages, milestones }) => (
          <SubscriberOrdersProvider uid={uid as string}>
            {
              ({ invoices, orders }) => (
                <Grid container direction="row"
                      sx={{
                        minHeight: 'calc(100vh - 90px)'
                        // overflow: 'hidden'
                      }}
                      wrap="nowrap"
                      spacing={2}>
                  <Grid item xs={4}>
                    <Paper
                      elevation={0}
                      sx={{
                        padding: 4,
                        height: '100%',
                        width: '100%'
                      }}
                      variant="outlined"
                    >
                      <List dense disablePadding>
                        <ListSubheader>Invoices</ListSubheader>
                        {
                          invoices
                            .map((invoice: QueryDocumentSnapshot) =>
                              <ListItem button onClick={() => setInvoice(invoice)} key={invoice.id}>
                                <ListItemText>
                                  {invoice.id}
                                </ListItemText>
                              </ListItem>
                            )
                        }
                        <ListItem onClick={handleAddInvoice} button>
                          <ListItemText>
                            + Add Invoice
                          </ListItemText>
                        </ListItem>
                        <ListSubheader>Orders</ListSubheader>
                        {
                          orders
                            .map((invoice: QueryDocumentSnapshot) =>
                              <ListItem button onClick={() => setInvoice(invoice)} key={invoice.id}>
                                <ListItemText>
                                  {invoice.id}
                                </ListItemText>
                              </ListItem>
                            )
                        }
                      </List>
                    </Paper>
                  </Grid>
                  <Grid item xs={8}>
                    <Paper
                      elevation={0}
                      sx={{
                        padding: 4,
                        height: '100%',
                        width: '100%'
                      }}
                      variant="outlined"
                    >
                      {
                        invoice && profile ?
                          <InvoiceCreationView invoice={invoice} uid={uid as string} profile={profile}/>
                          : null
                      }
                    </Paper>
                  </Grid>
                </Grid>
              )
            }
          </SubscriberOrdersProvider>
        )
      }
    </SubscriberProvider>
  );
}
